import { insertHtmlFragment } from '@otto-ec/global-resources/dom';
import { Snackbar } from './Snackbar';
import { BasketChangedEmitter } from './BasketChangedEmitter';

export interface PartialReloaderOptions {
    partialUrl: string;
    containerSelector: string;
    changedEvent: string;
}

type OnResponse = (redirectHappened: boolean) => void;

export class PartialReloader {
    constructor(
        private readonly options: PartialReloaderOptions,
        readonly snackbar: Snackbar,
        private readonly basketChangedEmitter: BasketChangedEmitter
    ) {}

    async trigger(onResponse?: OnResponse): Promise<void> {
        const response = await fetch(this.options.partialUrl);
        if (!response.ok) {
            /*                                                  */
            this.snackbar.showMessage();
            throw new Error(`PartialReload: ${this.options.partialUrl} failed with status ${response.status}`);
        }
        const redirectTo = response.headers.get('X-RedirectTo');
        if (redirectTo) {
            onResponse?.(true);
            window.location.href = redirectTo;
            return;
        }
        const html = await response.text();
        const container = document.querySelector<HTMLElement>(this.options.containerSelector);
        if (container) {
            /*                                                                                                                           */
            insertHtmlFragment(html, container, { replace: true });
            this.basketChangedEmitter.emit();
            document.dispatchEvent(new CustomEvent(this.options.changedEvent));
            onResponse?.(false);
        }
    }
}
